export const copyright = '©';
export const date = new Date().getFullYear();